import { Component, OnInit } from '@angular/core';
import { filterUndefined, trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Partner } from 'src/app/models/domain';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { PartnerService } from 'src/app/state';

@Component({
  selector: 'em-mould-developers',
  templateUrl: './mould-developers.component.html',
  standalone: false,
})
export class MouldDevelopersComponent implements OnInit {
  public partners$ = this.partnerService.partners$;
  public isLoading$ = this.partnerService.loading$;
  public error$ = this.partnerService.error$;
  public partners: Partner[] | undefined = [];
  public readonly trackByRef = trackByRef;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly equipmentFacade: EquipmentFacadeService,
    private readonly partnerService: PartnerService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.equipmentFacade.equipmentDetails$
        .pipe(
          filterUndefined(() => {
            this.partnerService.reset();
          }),
          switchMap((equipment) => this.partnerService.loadByObjectNumber(equipment.objectNumber))
        )
        .subscribe()
    );

    this.subscriptions.add(this.partners$.subscribe((partners) => (this.partners = partners)));
  }
}
